"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScaleSetting = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const NumberSetting_1 = require("./NumberSetting");
const MIN_SCALE = 0.1;
const MAX_SCALE = 10;
const ScaleSetting = ({ scale, setScale }) => {
    return ((0, jsx_runtime_1.jsx)(NumberSetting_1.NumberSetting, { min: MIN_SCALE, max: MAX_SCALE, step: 0.1, name: "Scale", formatter: (w) => {
            if (typeof w === 'number') {
                return `${w.toFixed(1)}x`;
            }
            return `${w}x`;
        }, onValueChanged: setScale, value: scale, hint: 'scaleOption' }));
};
exports.ScaleSetting = ScaleSetting;
